import { MobiDocument } from './MobiDocument';

export class ChampLibreResultDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private champlibre_id: number;
    private stringresult: string;
    private dateresult: string;
    private bigdecresult: number;
    private bigintresult: number;
    private boolresult: boolean;

    public constructor(champLibreResult: any) {
        super();
        this._id = champLibreResult._id;
        this._rev = champLibreResult._rev;
        this.id = champLibreResult.id;
        this.champlibre_id = champLibreResult.champlibre_id
        this.stringresult = champLibreResult.stringresult;
        this.dateresult = champLibreResult.dateresult;
        this.bigdecresult = champLibreResult.bigdecresult;
        this.bigintresult = champLibreResult.bigintresult;
        this.boolresult = champLibreResult.boolresult;

    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getChamplibre_id(): number {
        return this.champlibre_id;
    }

    public setChamplibre_id(champlibre_id: number): void {
        this.champlibre_id = champlibre_id;
    }

    public getStringresult(): string {
        return this.stringresult;
    }

    public setStringresult(stringresult: string): void {
        this.stringresult = stringresult;
    }

    public getDateresult(): string {
        return this.dateresult;
    }

    public setDateresult(dateresult: string): void {
        this.dateresult = dateresult;
    }

    public getBigdecresult(): number {
        return this.bigdecresult;
    }

    public setBigdecresult(bigdecresult: number): void {
        this.bigdecresult = bigdecresult;
    }

    public getBigintresult(): number {
        return this.bigintresult;
    }

    public setBigintresult(bigintresult: number): void {
        this.bigintresult = bigintresult;
    }

    public isBoolresult(): boolean {
        return this.boolresult;
    }

    public setBoolresult(boolresult: boolean): void {
        this.boolresult = boolresult;
    }
}